import React from 'react';
import PageHeaderSection from 'app/components/misc/PageHeaderSection';
import { RichText } from 'prismic-reactjs';
import * as S from './styles';

const FAQContent = ({ doc }) => {
  const questionsAndAnswers = doc.map((qna, index) => {
    return (
      <div key={index}>
        <S.Title>{RichText.asText(qna.question)}</S.Title>
        <S.Text>{RichText.render(qna.answer)}</S.Text>
      </div>
    );
  });

  return (
    <>
      <PageHeaderSection
        title="Frequently Asked Questions"
        subtitle="We always aim to serve our customers with security in mind"
      />
      <S.PageContent>
        <br />
        {questionsAndAnswers}
      </S.PageContent>
    </>
  );
};

export default FAQContent;
